<template>
  <div class="template">
    <img :src="getTemplateSrc(photo.templateCode)">
    <div class="template-photo">
      <img :src="getImageUrl(photo.photoUri)">
    </div>
  </div>
</template>

<script>
import { commonUtils } from '../../../utils/common'
export default {
  name: 'ExtraStyleTempalte',
  props: {
    photo: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
    }
  },
  methods: {
    getImageUrl (imageUri) {
      return commonUtils.getImageUrl(imageUri)
    },
    getTemplateSrc (code) {
      console.log(code)
      const src = require('../../../assets/images/extra-style/' + code + '.png')
      return src
    }
  }
}
</script>

<style scoped>
.template {
  position: relative;
}
.template img {
  position: relative;
  width: 100%;
  z-index: 1;
}
.template-photo {
  position: absolute;
  margin: auto;
  top: 15.6%;
  left: 0;
  right: 0;
  z-index: 1;
  width: 72%;
  height: 61%;
  text-align: center;
}
.template-photo img {
  width: 100%;
  height: 100%;
}
</style>
